
import React from 'react';
import { AlertTriangle } from "lucide-react";

interface ErrorMessageProps {
  error?: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ error }) => {
  if (!error) return null;
  
  return (
    <div className="flex items-center gap-1 validation-error text-sm mt-1">
      <AlertTriangle className="h-3 w-3" />
      <span>{error}</span>
    </div>
  );
};

export default ErrorMessage;
